import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CommonServices } from 'src/app/Common/CommonServices';
import { HostPortalClient, MyStats, User, WebinarClient, WebinarRoomOwnerDTO } from 'src/app/Services/WOWApi.Service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { MystatsUI } from 'src/app/Services/mystats-ui.model';
import { formatTimeSlot, slotToneFromLabel } from '../host-format';

@Component({
    selector: 'app-my-stats',
    templateUrl: './my-stats.component.html',
    styleUrls: ['./my-stats.component.css'],
    standalone: false
})
export class MyStatsComponent implements OnInit {
  loggedUser: User;
  webinarRooms:WebinarRoomOwnerDTO[] = [];
  timeSlotOption: any = [];
  period:string[] = ['Yesterday','CurrentWeek','CurrentMonthData','CurrentQuaterData'];
  myStats: MyStats[] = [];
  inputColumns = ['QueueTime', 'Yesterday', 'Week', 'Month','Quater'];
  displayColumns: string[];
  displayData: any[];
  inputData:MystatsUI[];
  webinarRoomControl = new UntypedFormControl('');
  constructor(private hostPortalClient:HostPortalClient,
    private webinarClient: WebinarClient,  
    private commonServices: CommonServices
    , private customServices:CustomServiceService) { }

  ngOnInit(): void {
   this.loggedUser = this.customServices.GetLoggedInUser();
    this.GetRooms();
    this.GetTimeSlot();
    
  }
  formatInputRow(row) {
    const output = {};
    
    output[0] = row;
    for (let i = 0; i < this.inputData.length; ++i) {
      output[this.inputData[i].QueueTime] = this.inputData[i][row];
    }

    return output;
  }
  GetTimeSlot() {
    this.hostPortalClient.getTimeSlots().subscribe(response => {
      this.timeSlotOption = response;
    })
  }
   
  GetRooms()
  {
    this.webinarClient.getWebinarRoomsByUser(this.loggedUser.id)
    .subscribe(data => {
      this.webinarRooms = data; 
      if (data.length > 0) {
        this.webinarRoomControl.setValue(data[0].webinarRoomId);
      }
        this.GetMyStats(this.webinarRooms[0].webinarRoomId);
    });
  } 

  GetStatsOfRoom(e) {
    this.GetMyStats(e.value);
  }

  formatTimeSlot(slot?: string): string {
    return formatTimeSlot(slot);
  }

  slotTone(slot?: string, index = 0) {
    return slotToneFromLabel(slot, index);
  }

  GetHeader(input)
  {
   switch(input)
   {
    case "QueueTime":
      return "Queue Times In Use";
      break ;
      case "Yesterday":
      return "Items closed Yesterday";
      break ;
      case "Week":
      return "Items  closed this week";
      break ;
      case "Month":
      return "Items closed this month";
      break ;
      case "Quater":
      return "Items closed this Quarter";
      break ;
      default:
        return input;
   }

  }
  GetMyStats(roomId)
  {
    this.displayData =[];
    // this.hostPortalClient.getMyStats(this.loggedUser.id, roomId).subscribe(data => {
      this.hostPortalClient.getMyStats(this.loggedUser.id, roomId).subscribe(data => {
  this.myStats = data;
  this.inputData= [];
  this.timeSlotOption.forEach((element, i) => {
    var cdata = new MystatsUI();
    cdata.QueueTime = element.name; 
    this.period.forEach(x => {
      var currentvalue = 0;
      var spanData = this.myStats.filter(y => y.timeSpan == x)[0]
      if(spanData != null)
      {
        var slotData = spanData.slotsData.filter(y => y.slot == element.name)[0];
        if(slotData != null)
        {
          currentvalue = slotData.webinarCount;
        }
      }
         switch(x)
         {
          case 'Yesterday':
            cdata.Yesterday = currentvalue.toString();
            break;
          case 'CurrentWeek': 
          cdata.Week = currentvalue.toString();
          break;
          case 'CurrentMonthData': 
          cdata.Month = currentvalue.toString();
          break;
          case 'CurrentQuaterData':
            cdata.Quater = currentvalue.toString();
            break;
            
         }
    });
    this.inputData.push(cdata); 
  })
   
  this.displayColumns = ['0'].concat(this.inputData.map(x => x.QueueTime.toString()));
  this.displayData = this.inputColumns.map(x => this.formatInputRow(x));
 
  console.log(this.inputData);
    });
  }

}
